const PainConfirmation = ({
  maxAttempts = 3,
  currentAttempts = 0,
  onYesAddAnother,
  onNoAddAnother,
  onFinish,
}) => {
  const isLastStep = maxAttempts === currentAttempts;

  return (
    <div className="new-modal-content text-center add_pain_area_block">
      <h4>Would you like to add another pain area?</h4>

      <div className="step-footer-block">
        <div className="back-next-btn">
          <button className="back-btn" onClick={onNoAddAnother}>
            No
          </button>
        </div>
        <div className="back-next-btn">
          <button
            className="common-btn"
            onClick={() => {
              if (isLastStep) {
                onFinish(false);
              } else {
                onYesAddAnother();
              }
            }}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default PainConfirmation;
